import LoadingEllipsis from 'client/components/common/LoadingEllipsis'
import * as React from 'react'

import { SchemaInterface } from '../../Interfaces/Schema/SchemaInterface'
import { ModelInterface } from '../../Interfaces/Settings/ModelInterface'
import { AreaInput } from './AreaInput'
import { DatePicker } from './DatePicker/DatePicker'
import Input from './Input/Input'
import { TestableInterface } from './interfaces/TestableInterface'
import { NumberInput } from './NumberInput'
import { SelectInput } from './SelectInput/SelectInput'
import { TranslatableType } from './Translatable'

export interface FieldCreatorPropsInterface extends TestableInterface {
  schema: SchemaInterface
  model?: ModelInterface
  name: string
  data?: () => any | { [key: string]: any }
  className?: string
  props: {
    automation: string
    [key: string]: any
    sortFn?: (a: any, b: any) => number
  }
  label?: string | JSX.Element
  translator: (key: string) => TranslatableType
  isLoading?: boolean
  resizable?: boolean
}

export class FieldCreator extends React.Component<FieldCreatorPropsInterface> {
  public render(): JSX.Element {
    let visible = true
    const field = this.props.schema.fields.filter((field) => {
      return field.name === this.props.name
    })[0]

    if (!field) {
      return null
    }

    if (field.hidden === true) {
      visible = false
    }

    const common: any = {
      label: this.props.label || this.props.translator(field.label),
      automation: this.props.automation,
    }

    if (this.props.model) {
      const modelField = this.props.model.fields.filter((field) => {
        return field.name === this.props.name
      })

      if (modelField && modelField.length === 1) {
        common.value = modelField[0].default
        visible = modelField[0].visible
      }
    }

    if (visible === false) {
      return null
    }

    let el: JSX.Element = null
    switch (field.type) {
      case 'text': {
        el = <Input {...common} {...this.props.props} />
        break
      }
      case 'date': {
        el = <DatePicker {...common} {...this.props.props} />
        break
      }
      case 'area': {
        el = (
          <AreaInput
            resizable={this.props.props?.resizable}
            className={this.props.props?.resizable ? ['resizable'] : ['default']}
            {...common}
            {...this.props.props}
          />
        )
        break
      }
      case 'integer': {
        if (typeof common.value !== 'undefined') {
          common.value = parseFloat(common.value)
        }
        el = <NumberInput {...common} {...this.props.props} />
        break
      }
      case 'select': {
        el = <SelectInput {...common} map={this.props.props.map} value={this.props.props.value} {...this.props.props} />
        break
      }
      default:
        el = <Input {...common} {...this.props.props} />
        break
    }

    return (
      <div className={this.props.className || ''}>
        {this.props.isLoading && <LoadingEllipsis />}
        {!this.props.isLoading && el}
        {this.props.children}
      </div>
    )
  }
}
